import React from 'react';
import SEO from './SEO';

/**
 * Helmet Component (Legacy Wrapper)
 * 
 * This is a backwards-compatible wrapper around the new SEO component.
 * For new implementations, consider using the SEO component directly
 * for more control over structured data and advanced SEO features.
 * 
 * @deprecated Use components/SEO directly for new implementations
 */
const HelmetComponent = ({
  page = '',
  name,
  declensions,
  meta,
  metaImageUrl,
  canonicalUrl,
  // New props that can be passed through
  schema,
  additionalSchemas,
  breadcrumbs,
  article,
  noIndex,
  noFollow,
  ogType,
  includeHreflang
}) => {
  return (
    <SEO
      page={page}
      name={name}
      declensions={declensions}
      meta={meta}
      metaImageUrl={metaImageUrl}
      canonicalUrl={canonicalUrl}
      schema={schema}
      additionalSchemas={additionalSchemas}
      breadcrumbs={breadcrumbs}
      article={article}
      noIndex={noIndex}
      noFollow={noFollow}
      ogType={ogType}
      includeHreflang={includeHreflang}
    />
  );
};

export default HelmetComponent;
